import { CatalogModification } from 'amqp-contracts';

export type MobileBffGetCatalogResponseDto = Omit<CatalogModification, 'availableVehicleCount'> & {
  available: boolean;
};
